import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { contact } from 'contact/model/contact.fragments';
import { ContactSortProperty } from 'contact/model/contact.sort-property';
import { SortDirection } from 'infrastructure/common/model/api.sort-direction';

import { ApiQuery } from '../../../../common/model/api.query';
import { ContactOutput } from '../model/contact.output';

export interface FetchContactsParams {
	readonly lastMeetingStartTimestamp?: number;
	readonly sortProperty?: ContactSortProperty;
	readonly lastMeetingEndTimestamp?: number;
	readonly sortDirection?: SortDirection;
	readonly categoriesName?: string[];
	readonly companiesName?: string[];
	readonly chunkSize?: number;
	readonly offset?: number;
	readonly name?: string;
}

@Injectable({ providedIn: 'root' })
export class FetchContactsApiQuery extends ApiQuery<
	ContactOutput[],
	FetchContactsParams
> {
	client = 'iam';
	document = gql`
		query FetchContacts(
			$lastMeetingStartTimestamp: Long
			$lastMeetingEndTimestamp: Long
			$categoriesName: [String]
			$companiesName: [String]
			$sortDirection: Direction
			$sortProperty: ContactSort
			$chunkSize: Int
			$offset: Int
			$name: String
		) {
			fetchContacts(
				lastMeetingStartTimestamp: $lastMeetingStartTimestamp
				lastMeetingEndTimestamp: $lastMeetingEndTimestamp
				categoriesName: $categoriesName
				companiesName: $companiesName
				sortDirection: $sortDirection
				sortProperty: $sortProperty
				chunkSize: $chunkSize
				offset: $offset
				name: $name
			) {
				...Contact
			}
		}
		${contact}
	`;
	method = 'fetchContacts';
}
